import { AssetCategory } from '@common/enums';
import { PatientFollowsPolicyWithAttachmentFormSection } from './PatientFollowsPolicyWithAttachmentFormSection';

export function LifestyleFormSections() {
    return (
        <PatientFollowsPolicyWithAttachmentFormSection
            assetCategory={AssetCategory.lifestyleAttachment}
            patientFollowsPolicyFieldKey="patientFollowsLifestylePolicy"
            title="Leefstijlveranderingen"
        />
    );
}
